import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class LSHeader extends Component {
  render(){
    return (
        <header className="header">
        <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
        <Link className="navbar-brand" to="/"><img src="/img/logo.png" alt="logo" /></Link>
        <div className="d-flex alter_nav_back">
        <Link to="/" className="btn btn-outline btn-small" type="button">Back</Link>
        </div>
        </div>
        </nav>
        </header>
        );
  }
}
export default LSHeader;